import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useApp } from '../contexts/AppContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiX, FiCheck, FiInfo, FiAlertTriangle } = FiIcons;

const NotificationCenter = () => {
  const { notifications, removeNotification, showNotificationCenter } = useApp();

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'success': return FiCheck;
      case 'warning': return FiAlertTriangle;
      case 'info': return FiInfo;
      default: return FiInfo;
    }
  };

  const getNotificationStyles = (type) => {
    switch (type) {
      case 'success': return 'bg-green-50 border-green-200 text-green-800';
      case 'warning': return 'bg-yellow-50 border-yellow-200 text-yellow-800';
      case 'error': return 'bg-red-50 border-red-200 text-red-800';
      default: return 'bg-blue-50 border-blue-200 text-blue-800';
    }
  };

  // Only render if there are notifications AND showNotificationCenter is true
  if (notifications.length === 0 || !showNotificationCenter) return null;

  return (
    <div className="fixed top-20 right-3 md:right-6 z-50 space-y-2 max-w-[calc(100vw-24px)] sm:max-w-[320px] pointer-events-none">
      <AnimatePresence initial={false}>
        {notifications.map((notification) => (
          <motion.div
            key={notification.id}
            initial={{ opacity: 0, x: 50, y: 0, scale: 0.8 }}
            animate={{ opacity: 1, x: 0, y: 0, scale: 1 }}
            exit={{ opacity: 0, x: 50, scale: 0.8 }}
            transition={{ type: 'spring', damping: 20 }}
            className={`p-3 md:p-4 rounded-lg border shadow-lg pointer-events-auto ${getNotificationStyles(notification.type)}`}
          >
            <div className="flex items-start space-x-2">
              <SafeIcon
                icon={getNotificationIcon(notification.type)}
                className="w-4 h-4 md:w-5 md:h-5 mt-0.5 flex-shrink-0"
              />
              <div className="flex-1 min-w-0">
                <h4 className="font-medium text-sm md:text-base truncate">{notification.title}</h4>
                {notification.message && (
                  <p className="text-xs md:text-sm opacity-75 mt-1 line-clamp-2">{notification.message}</p>
                )}
              </div>
              <button
                onClick={() => removeNotification(notification.id)}
                className="text-gray-400 hover:text-gray-600 flex-shrink-0 p-1 touch-target h-8 w-8"
                aria-label="Close notification"
              >
                <SafeIcon icon={FiX} className="w-4 h-4" />
              </button>
            </div>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default NotificationCenter;